import React from "react";

export const RPGGameClanLeaveIcon = () => {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.51621 0L5.64449 0.017284L5.69259 0.0864197V2.6963L5.93312 2.67901V0.362963H6.18967V1.74568H6.4302V2.03951H6.18967V2.6963H6.68676V2.31605H7.45643V2.6963H7.72902V2.31605H8.06576V2.6963H8.51474V2.99012H8.06576V3.35309L8.80336 3.37037L8.8675 3.45679L8.85147 3.56049L8.78733 3.62963H8.06576V4.0963H9.1401L10.0541 4.07901L10.0701 3.97531L10.4389 3.95802L10.455 3.97531V4.47654H9.557L9.49286 4.42469L9.02785 4.40741V4.78765H10.936L11.0001 4.87407V4.99506L10.952 5.0642L10.9039 5.08148H9.02785V5.35802L9.01182 5.37531H8.77129V5.08148H8.59491L8.5468 5.0642L8.53077 4.78765H8.77129L8.75526 4.42469L8.06576 4.40741V5.09877L7.56868 5.11605L7.50454 5.1679V5.28889L7.58471 5.37531L8.06576 5.39259V5.65185H8.53077V5.80741L8.51474 5.94568H8.06576L8.08179 6.20494H8.77129V5.65185H9.02785V6.49876L9.01182 6.51605H8.06576V6.77531H9.52493V6.44691H10.7276V7.08642H9.02785V7.32839L9.01182 7.51852H8.77129L8.75526 7.08642H8.06576V8.0716H8.27421V7.36296H8.51474L8.53077 7.46667V8.01975L8.51474 8.38272H8.06576V8.65926H9.28441V7.76049H9.52493V8.95309H8.51474L8.53077 9.43704H10.6794V9.73086H7.88937L7.8092 9.67901L7.74506 9.55802L7.72902 8.65926L7.4885 8.64198L7.50454 9.62716L7.56868 9.8L7.66489 9.92099L7.82523 10.0074L7.88937 10.0247L10.4389 10.042V10.3531H10.1182V10.6642H10.455V10.9235H10.1022L10.1182 11.079L10.1022 11.1654H9.86167V10.9235H9.54097V11.1309H9.30045V10.6642H9.86167L9.84563 10.3704L8.06576 10.3531V10.6469H9.02785V11.3383H8.77129V10.9407H8.53077V11.2864L8.51474 11.3556H8.01765L7.92144 11.2L7.71299 10.837L7.45643 10.3877L7.28005 10.0938L7.19987 9.99012V4.39012H4.13721V1.76296H4.66636V3.8716H5.67656L5.66052 3.61235H5.01913L4.93895 3.59506V1.52099H5.19551V2.67901L5.43603 2.6963V0.0691358L5.51621 0ZM5.19551 2.99012V3.28395H5.93312L5.94915 3.26667V3.11111L5.93312 2.99012H5.19551ZM6.4302 2.99012V3.28395H6.95935V2.99012H6.4302ZM6.18967 3.59506V3.8716H7.19987V3.59506H6.18967ZM7.66489 3.92346L7.55264 3.97531L7.4885 4.0963L7.50454 4.21728L7.56868 4.3037L7.63282 4.33827L7.76109 4.32099L7.84127 4.25185L7.8573 4.21728V4.06173L7.77713 3.95802L7.66489 3.92346ZM7.60075 5.96296L7.52057 6.01481L7.50454 6.0321V6.17037L7.56868 6.23951H7.69696L7.74506 6.18765L7.76109 6.10123L7.71299 5.99753L7.64885 5.96296H7.60075ZM7.4885 6.75802V7.60494H7.74506V6.77531L7.63282 6.75802H7.4885ZM8.08179 9.16049L8.06576 9.17778V9.43704H8.25818V9.16049H8.08179Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.93848 0.362961H5.179V0.62222H4.95451L4.93848 0.604936V0.362961Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.44629 0.656784H6.83113L6.94337 0.674068V0.950611H6.44629V0.656784Z"
        fill="#C6B7FF"
      />
      <path
        d="M7.26328 0.674088H7.35949L7.43966 0.725939V2.03952H7.19914L7.18311 1.88396L7.19914 0.725939L7.26328 0.674088Z"
        fill="#C6B7FF"
      />
      <path
        d="M3.65576 0.69136H3.88025V0.916052H3.65576V0.69136Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.13721 0.898773H4.66636V1.53828H4.13721V0.898773Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.93848 0.916046H5.179V1.22716H4.93848V0.916046Z"
        fill="#C6B7FF"
      />
      <path
        d="M2.64568 1.22716H2.75793L2.82207 1.26173L2.8381 1.29629V2.50617L2.77396 2.52345H2.58154V1.29629L2.64568 1.22716Z"
        fill="#C6B7FF"
      />
      <path
        d="M3.23894 1.22716H3.89637V6.49876L3.81619 6.51605H1.57131L1.49113 6.49876V6.22222H3.04652V6.0321L3.06255 5.94568H1.49113V5.11605H2.58151V4.82222L2.51737 4.8395H1.85994L1.74769 4.78765L1.4751 4.49382L1.50717 4.42469L1.61941 4.28642L1.69959 4.32098L1.8439 4.47654L1.90804 4.52839L3.04652 4.54568V4.28642L2.58151 4.26913V2.83456H2.82203L2.83806 2.85185V3.97531H3.06255V3.57777H3.25497L3.36722 3.64691H3.47946L3.5436 3.61234L3.5917 3.50864L3.57567 3.37037L3.47946 3.28395H3.36722L3.31911 3.30123L3.27101 3.37037H3.06255V2.71358H3.23894V2.31605H3.60774V2.05679H3.23894V1.22716ZM3.44739 4.02716L3.36722 4.09629L3.35118 4.2L3.39929 4.28642L3.43136 4.3037H3.52756L3.5917 4.25185L3.60774 4.14815L3.55963 4.06173L3.4955 4.02716H3.44739ZM3.36722 5.2716V5.37531L3.44739 5.35802L3.41532 5.28889L3.36722 5.2716ZM1.74769 5.39259V5.65185H3.04652V5.39259H1.74769Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.44629 1.43457H6.94337V1.71111L6.92734 1.7284H6.44629V1.43457Z"
        fill="#C6B7FF"
      />
      <path d="M7.729 1.45184H7.92142V1.65925H7.729V1.45184Z" fill="#C6B7FF" />
      <path
        d="M8.11377 1.45184H8.29015V1.65925H8.11377V1.45184Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.4668 1.45184H8.65922V1.65925H8.48283L8.4668 1.45184Z"
        fill="#C6B7FF"
      />
      <path
        d="M2.08447 1.78024H2.325V2.12592H2.08447V1.78024Z"
        fill="#C6B7FF"
      />
      <path d="M7.729 1.83209H7.92142V2.0395H7.729V1.83209Z" fill="#C6B7FF" />
      <path
        d="M8.11377 1.83209H8.29015V2.0395H8.11377V1.83209Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.4668 1.83209H8.65922V2.0395H8.48283L8.4668 1.83209Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.05988 1.97037H9.3004V2.31605H9.65317V2.57531H9.3004V2.95555H9.05988V2.57531L8.72314 2.59259V2.31605H9.05988V1.97037Z"
        fill="#C6B7FF"
      />
      <path
        d="M2.08447 2.33333H2.325V4.25185H2.08447V2.33333Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.37939 2.57532H1.7963V2.88643H1.37939V2.57532Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.37921 3.21481H1.49146L1.61974 3.26667L1.71595 3.3358L1.79612 3.47407L1.81216 3.52592V3.73333L1.74802 3.88889L1.61974 4.00987L1.45939 4.06173L1.31507 4.04444L1.18679 3.97531L1.07455 3.83704L1.04248 3.73333V3.56049L1.10662 3.38765L1.2349 3.26667L1.37921 3.21481Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.81308 3.21481H9.94136L10.0215 3.30123V3.4395L9.9574 3.52592H9.81308L9.74895 3.45679L9.73291 3.42222V3.30123L9.81308 3.21481Z"
        fill="#C6B7FF"
      />
      <path
        d="M10.3105 3.24937H10.503V3.49135H10.3105V3.24937Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.26801 3.49135L9.38025 3.50863L9.44439 3.57777V3.73332L9.36422 3.80246H9.23594L9.1718 3.73332L9.15576 3.6469L9.20387 3.52592L9.26801 3.49135Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.433105 4.07903H0.673629V4.321H0.433105V4.07903Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.962402 4.28642H1.17086V4.47655H0.962402V4.28642Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.30615 4.56296H8.53064V4.77037H8.30615V4.56296Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.1369 4.66667H6.95905L6.97508 4.68396L6.99112 10.0765L7.2156 10.4568L7.35992 10.7161L7.50423 10.9753L7.8089 11.5284L7.93718 11.7531L8.19373 12.237L8.46633 12.721L8.73892 13.2222L8.83513 13.3951V13.4296H8.41822L8.11356 12.7728V12.7383L7.79286 12.7556L8.06545 13.4296L8.11356 13.5852H7.72872L7.64855 13.3951L7.34388 12.5136L7.05526 11.684L6.89491 11.2346L6.60628 10.3877L6.5261 10.1457V10.0938H6.71852L6.70249 4.9605L4.37743 4.94321V10.0938H4.58588L4.55381 10.2494L4.26518 11.1136L4.00862 11.8395L3.72 12.6519L3.52758 13.1877H3.15878L3.20688 13.0148L3.31912 12.7556L2.99843 12.7728L2.74187 13.3259L2.67773 13.4296H2.27686L2.40513 13.1531L2.53341 12.9284L2.80601 12.4272L2.99843 12.0815L3.15878 11.8049H3.62379V11.563H3.28705L3.35119 11.4247L3.49551 11.1654L3.68793 10.8198L3.96052 10.3358L4.10483 10.0938L4.12087 4.68396L4.1369 4.66667Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.513184 4.77037H1.20268L1.21872 4.78765V5.66914H0.513184V4.77037Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.49849 5.11604H8.51453V5.3753L8.29004 5.35802V5.13333L8.49849 5.11604Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.6342 5.30617H6.43011V6.2395H4.61816V5.32345L4.6342 5.30617ZM5.22749 5.49629L5.24353 5.58271L5.33973 5.73827L5.3237 5.84197L5.22749 5.99753V6.04938H5.3237L5.41991 5.89382L5.51612 6.04938H5.62836L5.53215 5.85925L5.50008 5.8074L5.51612 5.72098L5.61233 5.51358L5.53215 5.49629L5.48405 5.51358L5.43594 5.61728V5.65185H5.40387L5.3718 5.56543L5.3237 5.49629H5.22749ZM5.11525 5.49629L4.82662 5.51358V6.04938H5.14732L5.16335 5.96296L5.14732 5.94567L4.93886 5.92839L4.92283 5.82469H5.11525L5.13128 5.8074V5.72098H4.92283V5.61728H5.14732V5.49629H5.11525ZM5.67647 5.51358V6.03209L5.6925 6.04938H5.77268L5.78871 6.01481V5.51358H5.67647ZM5.85285 5.51358V5.61728H5.98113V6.03209L5.99717 6.04938H6.09337V5.61728H6.22165V5.51358H5.85285Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.81348 5.61729H10.4549V6.01483H9.90969L9.81348 5.99754V5.61729Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.28418 5.65184H9.5247V6.18764H9.28418V5.65184Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.0641396 6.22221H1.25072V6.51604H0.144314L0.0481047 6.48147L0 6.42962V6.29135L0.0641396 6.22221Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.994141 6.75804H1.20259V7.03458H1.01018L0.994141 7.0173V6.75804Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.50725 6.77531H1.7157V7.03457H1.50725L1.49121 6.96544V6.7926L1.50725 6.77531Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.93989 6.77531H3.83201L3.89615 6.7926V9.97285L3.70373 10.3012L3.49528 10.6642L3.22268 11.1482L3.06233 11.4247H2.59732L2.58129 11.4074V10.9407H2.32473V11.4247H2.08421V10.9407H1.79558V10.6642L3.0463 10.6469V10.4222L3.06233 10.3877H2.61336V10.0593L2.62939 10.042H3.0463V9.73087H0.111913L0.0477732 9.66173L0.0317383 9.54075L0.079843 9.45433L0.0958779 9.43704H2.58129V8.95309H1.69937L1.58712 8.93581V9.17778H1.42677L1.41074 9.1605V8.65926H3.0463V8.38272H2.16438L2.14835 7.98519L2.16438 7.91606H3.0463V7.63951H2.16438L2.14835 7.51852V7.36297L2.16438 7.34568H2.56525V7.06914H1.93989V6.77531ZM2.83785 7.06914V7.34568H3.06233V7.06914H2.83785ZM3.4151 7.08643L3.367 7.15556V7.27655L3.43114 7.34568L3.51131 7.36297L3.60752 7.29383L3.62356 7.20741L3.57545 7.10371L3.54338 7.08643H3.4151ZM3.367 7.88149L3.35096 7.91606V8.38272L3.38303 8.45186L3.44717 8.48643L3.54338 8.46914L3.60752 8.40001V7.88149H3.367Z"
        fill="#C6B7FF"
      />
      <path d="M0.352539 7H0.737377V7.3284H0.352539V7Z" fill="#C6B7FF" />
      <path
        d="M5.99707 7.25925H6.49415V7.51851H5.99707V7.25925Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.994141 7.34569H1.90813L1.92416 7.36297V7.63952H0.994141V7.34569Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.87738 7.34569H9.97359L10.0538 7.41482L10.0698 7.44939V7.58766L9.98963 7.67408L9.90945 7.69137L9.82928 7.6568L9.76514 7.57038V7.44939L9.82928 7.36297L9.87738 7.34569Z"
        fill="#C6B7FF"
      />
      <path
        d="M10.4385 7.55309H10.7271V7.8642H10.4385V7.55309Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.77148 7.77779H9.01201L9.02804 7.81235L9.01201 8.38272H8.77148V7.77779Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.20264 7.91605H1.92421V8.38271H1.20264V7.91605Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.81348 8.17531H10.0219V8.41728H9.81348V8.17531Z"
        fill="#C6B7FF"
      />
      <path
        d="M10.2949 8.17531H10.4873V8.41728H10.2949V8.17531Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.30181 8.20987L6.36595 8.24444L6.59044 8.5037L6.62251 8.57283L6.54234 8.67654L6.41406 8.57283V9.17777H6.23767L6.22164 8.57283L6.09336 8.67654L6.01318 8.59012L6.02922 8.52098L6.28578 8.24444L6.30181 8.20987Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.978516 8.38271H1.18697L1.17093 8.59011H0.978516V8.38271Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.449219 8.43457H0.721812V8.91852L0.673707 8.9358H0.545428L0.449219 8.91852V8.43457Z"
        fill="#C6B7FF"
      />
      <path
        d="M10.2949 8.55556L10.4873 8.57284V9.14321H10.2949V8.55556Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.81348 8.72841H10.0219V9.14322H9.81348V8.72841Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.07473 8.91852L1.18697 8.9358V9.16049H0.978516V8.9358L1.07473 8.91852Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.23779 9.38519H6.41418V9.95556L6.23779 9.93828V9.38519Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.95656 10.042H2.29329L2.3414 10.0592V10.3704H1.86035V10.0592L1.95656 10.042Z"
        fill="#C6B7FF"
      />
      <path
        d="M0.688965 10.0592H0.961558V10.3704H0.705L0.688965 10.3185V10.0592Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.23438 10.0592H1.49093V10.3704H1.23438V10.0592Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.74653 10.0938H4.95498L4.84274 10.6296L4.63428 11.5975L4.4579 12.4444L4.32962 13.0494L4.20134 13.6889L4.18531 13.7235H3.73633L3.84857 13.2914L3.97685 12.842L4.23341 11.8914L4.37772 11.3901L4.60221 10.5951L4.73049 10.1457L4.74653 10.0938Z"
        fill="#C6B7FF"
      />
      <path
        d="M5.11499 10.0938H5.29138L5.25931 10.5605L5.11499 12.0815L5.01878 13.0667H4.66602L4.71412 12.6346L4.79429 12.1333L4.90654 11.3556L5.03482 10.5259L5.09896 10.1284L5.11499 10.0938Z"
        fill="#C6B7FF"
      />
      <path
        d="M5.43604 10.0938H5.66052L5.67656 10.3704L5.50017 10.3877L5.43604 10.3704V10.0938Z"
        fill="#C6B7FF"
      />
      <path
        d="M5.82031 10.0938H5.9967L6.15705 11.0099L6.4136 12.6691L6.62206 13.9654L6.60602 14H6.23722L6.22119 13.9481L6.09291 12.8765L6.02877 12.3407L5.91652 11.2L5.83635 10.4222L5.82031 10.2839V10.0938Z"
        fill="#C6B7FF"
      />
      <path
        d="M6.17334 10.0938H6.36576L6.59025 10.8889L6.89491 11.9432L7.21561 13.0839L7.37596 13.6889V13.7235H6.94302L6.76663 12.9111L6.55818 11.9259L6.31765 10.837L6.22144 10.4222L6.17334 10.1802V10.0938Z"
        fill="#C6B7FF"
      />
      <path
        d="M5.4197 10.6469H5.6923L5.7404 11.4074L5.82058 12.8593L5.85265 13.7926V13.9827L5.83661 14H5.27539L5.29143 13.4296L5.30746 12.8247L5.33953 12.1679L5.38763 11.1654L5.4197 10.6469Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.21898 10.7679H1.44347V11.1136H1.79624V11.3556L1.7802 11.3729H1.44347V11.7358H1.20294V11.3729H0.866211V11.1136H1.20294V10.7852L1.21898 10.7679Z"
        fill="#C6B7FF"
      />
      <path
        d="M8.22607 11.6494H9.66922L9.68525 11.6667V11.9432L8.32228 11.9605L8.24211 11.7531L8.22607 11.6494Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.73145 11.7012L1.95593 11.7185V11.9432L1.9399 11.9605L1.73145 11.9432V11.7012Z"
        fill="#C6B7FF"
      />
      <path
        d="M2.26074 11.7012H2.50127V12.237H2.26074V11.7012Z"
        fill="#C6B7FF"
      />
      <path
        d="M1.60352 12.3407H1.87611V12.6173H1.60352V12.3407Z"
        fill="#C6B7FF"
      />
      <path
        d="M9.0918 12.3407H9.38043V12.6173H9.0918V12.3407Z"
        fill="#C6B7FF"
      />
      <path
        d="M4.61818 13.3605H4.95491V13.5161L4.90681 14H4.52197L4.57008 13.5852L4.61818 13.3605Z"
        fill="#C6B7FF"
      />
    </svg>
  );
};
